import * as React from "react"
import { FormControl } from "@mui/material"
import { useController, useFormContext } from "react-hook-form"
import { FormField } from "./types"
import { useCallback } from "react"
import { FormLabel } from "./FormLabel"
import { FileDropZone, Props as FileDropZoneProps } from "../FileDropZone/FileDropZone"

import styles from "./Forms.module.scss"
import { trackFormEvent } from "./utils"

export interface Props
  extends FormField,
    Pick<FileDropZoneProps, "accept" | "disabled" | "filePreview" | "maxFiles" | "maxSize"> {}

export const Files = ({ disabled, label, name, rules, accept, maxFiles, maxSize, filePreview, tracking }: Props) => {
  const { control } = useFormContext()
  const controller = useController({ name, control, rules })

  const error = controller.formState.errors[name]
  const errorProps = error ? { error: error.message?.toString() } : {}

  const handleFilesDropped = useCallback(
    async (files: File[]) => {
      controller.field.onChange(files)

      if (tracking?.shouldTrackValueChange && files.length) {
        await trackFormEvent("Form Value Provided", tracking, name, label)
      }
    },
    [controller.field, label, name, tracking]
  )

  const droppedFiles = controller.field.value as File[]

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}

      <FileDropZone
        disabled={disabled}
        onFilesDropped={handleFilesDropped}
        droppedFiles={droppedFiles}
        accept={accept}
        maxFiles={maxFiles}
        maxSize={maxSize}
        filePreview={filePreview}
      />

      {error && <span className={styles.errorLabel}>{errorProps.error}</span>}
    </FormControl>
  )
}

export default Files
